import React, { FC } from 'react';
import  styles from './VisaCard.module.scss';


interface VisaCardProps {
  xPosition:number
}

const VisaCard: FC<VisaCardProps> = ({xPosition = 5}) => {
  return (
     <svg
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            viewBox="0 0 108 63"
            width="100px"
          >
            <defs>
              <rect id="path-1" x="0" y="1" width="22" height="13"></rect>
            </defs>
            <g
              id="Icons/cvv"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <rect
                id="Rectangle"
                fill="#3665AC"
                fillRule="nonzero"
                x="0"
                y="0"
                width="108"
                height="63"
                rx="5"
              ></rect>
              <rect
                id="Rectangle-2"
                fill="#000000"
                fillRule="nonzero"
                opacity="0.550956157"
                x="0"
                y="12"
                width="108"
                height="10"
              ></rect>
              <rect
                id="Rectangle-2"
                fill="#FFFFFF"
                fillRule="nonzero"
                x="5"
                y="29"
                width="69"
                height="13"
              ></rect>
              <g id="123" transform="translate(80.000000, 28.000000)">
                <g
                  id="Rectangle-path"
                  transform="translate(11.000000, 7.500000) scale(-1, 1) translate(-11.000000, -7.500000) "
                >
                  <use
                    fill="#FFFFFF"
                    fillRule="evenodd"
                    xlinkHref="#path-1"
                  ></use>
                  <rect
                    stroke="#E7412A"
                    strokeWidth="1"
                    x="0.5"
                    y="1.5"
                    width="21"
                    height="12"
                  ></rect>
                </g>
                <text
                  fill="#E7412A"
                  font-family="OpenSans-Bold, Open Sans"
                  font-size="10"
                  font-weight="bold"
                >
                  <tspan x={xPosition} y="11">
                    123
                  </tspan>
                </text>
              </g>
            </g>
          </svg>
  );
};



export default VisaCard;
